var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.31941 3.27335L12.776 6.54786V0L9.45857 1.99066L7.31941 3.27335Z",
    fill: "url(#paint0_linear_111_3204)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2326 3.27335L12.776 6.54786V0L16.0934 1.99066L18.2326 3.27335Z",
    fill: "url(#paint1_linear_111_3204)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12944 4.19386C6.0247 4.13102 5.89384 4.13102 5.7891 4.19386L0.1625 7.5698C-0.125156 7.74239 -0.00279073 8.18417 0.33267 8.18417H11.5859C11.9213 8.18417 12.0437 7.74239 11.756 7.5698L6.12944 4.19386ZM19.7701 4.19386C19.6653 4.13102 19.5345 4.13102 19.4297 4.19386L13.8031 7.5698C13.5155 7.74239 13.6378 8.18417 13.9733 8.18417H25.2265C25.562 8.18417 25.6843 7.74239 25.3967 7.5698L19.7701 4.19386Z",
    fill: "url(#paint2_linear_111_3204)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2264 8.86621H0.330633C0.147962 8.86621 -0.00012207 9.0143 -0.00012207 9.19697V10.5845C-0.00012207 10.7672 0.147962 10.9153 0.330633 10.9153H25.2264C25.4091 10.9153 25.5572 10.7672 25.5572 10.5845V9.19697C25.5572 9.0143 25.4091 8.86621 25.2264 8.86621Z",
    fill: "url(#paint3_linear_111_3204)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.86609 12.2692C1.86609 11.8983 2.16673 11.5977 2.5376 11.5977H6.67845C7.04931 11.5977 7.34996 11.8983 7.34996 12.2692V24.7938C7.34996 25.0276 7.22833 25.2446 7.02887 25.3666L2.88802 27.8997C2.44056 28.1735 1.86609 27.8515 1.86609 27.3269V12.2692ZM18.2073 12.2692C18.2073 11.8983 18.5079 11.5977 18.8788 11.5977H23.0196C23.3905 11.5977 23.6911 11.8983 23.6911 12.2692V24.7138C23.6911 24.9477 23.5695 25.1646 23.37 25.2867L19.2292 27.8198C18.7817 28.0935 18.2073 27.7715 18.2073 27.2469V12.2692ZM10.5113 11.5977C10.1404 11.5977 9.8398 11.8983 9.8398 12.2692V22.318C9.8398 22.5543 9.96403 22.7732 10.1669 22.8945L14.3078 25.3684C14.7554 25.6358 15.3237 25.3133 15.3237 24.7919V12.2692C15.3237 11.8983 15.023 11.5977 14.6522 11.5977H10.5113Z",
    fill: "url(#paint4_linear_111_3204)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_111_3204",
    x1: 6.53595,
    y1: -0.49605,
    x2: 14.2297,
    y2: 0.596823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BCD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_111_3204",
    x1: 19.0161,
    y1: -0.49605,
    x2: 11.3223,
    y2: 0.596823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BCD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_111_3204",
    x1: 29.2274,
    y1: 3.84085,
    x2: 12.2406,
    y2: 22.1687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BCD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_111_3204",
    x1: 29.2267,
    y1: 8.71098,
    x2: 22.5669,
    y2: 22.8701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BCD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_111_3204",
    x1: 26.8248,
    y1: 10.3551,
    x2: -3.03309,
    y2: 17.1274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BCD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.814bc06eecc7572e60898d758a261981.svg";
export { ForwardRef as ReactComponent };